import React from 'react';

export interface IconGoogleProps {
  className?: string;
  size?: number | string;
  color?: string;
  fill?: string;
  stroke?: string;
}

const IconGoogle: React.FC<IconGoogleProps> = ({ 
  className = '', 
  size = 24, 
  color = 'currentColor', 
  fill, 
  stroke 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      color={color}
      fill={fill || 'none'}
    >
       <path d="M20.82 12.2089C20.82 11.5574 20.7615 10.931 20.653 10.3296H12V13.8835H16.9445C16.7316 15.0319 16.0843 16.005 15.1112 16.6564V18.9617H18.0805C19.8177 17.3622 20.82 15.0069 20.82 12.2089Z" fill={fill || "#4285F4"} /> <path d="M12.0001 21.1876C14.4807 21.1876 16.5604 20.3649 18.0805 18.9617L15.1113 16.6565C14.2886 17.2077 13.2362 17.5335 12.0001 17.5335C9.60715 17.5335 7.58173 15.9173 6.85925 13.7457H3.78979V16.1261C5.30156 19.1288 8.4086 21.1876 12.0001 21.1876Z" fill={fill || "#34A853"} /> <path d="M6.85918 13.7457C6.67543 13.1945 6.57102 12.6056 6.57102 12.0001C6.57102 11.3946 6.67543 10.8057 6.85918 10.2545V7.87408H3.78972C3.14659 9.15437 2.81193 10.5674 2.8125 12.0001C2.8125 13.4826 3.16747 14.8858 3.78972 16.1261L6.85918 13.7457Z" fill={fill || "#FBBC05"} /> <path d="M12.0001 6.46662C13.349 6.46662 14.5601 6.93017 15.5122 7.84057L18.1474 5.20543C16.5562 3.7229 14.4765 2.8125 12.0001 2.8125C8.4086 2.8125 5.30156 4.87134 3.78979 7.87398L6.85925 10.2544C7.58173 8.08278 9.60715 6.46662 12.0001 6.46662Z" fill={fill || "#EA4335"} />  
    </svg>
  );
};

export default IconGoogle;
